import React from "react";
import { Layout } from "core/components/Layout";
import { HistoryDatePicker } from "history/components/HistoryDatePicker";
import { HistoryHeader } from "history/components/HistoryHeader";
import { HistoryList } from "history/components/HistoryList";
import {
  AssigneeFilters,
  BuildingFilters,
  TaskTypeFilters,
} from "tasks/components/Filters";

export const HistoryView = () => {
  return (
    <Layout
      pageSubheader={
        <HistoryHeader>
          <HistoryDatePicker />
          <AssigneeFilters />
          <BuildingFilters />
          <TaskTypeFilters />
        </HistoryHeader>
      }
      pageTitle="History"
    >
      <HistoryList />
    </Layout>
  );
};
